import { useState, createContext, useEffect } from "react"
import { StationMap } from "components/map/StationMap.tsx"
import { useMmsService } from "services/mms/context/MmsServiceContext.tsx"
import StationList from "layouts/station/StationList.tsx"
import { Grid } from "@mui/material"
import { OreveButton } from "components/button/OreveButton.tsx"
import { SaveAltOutlined } from "@mui/icons-material"
import type { StationGeojson, StationFeature } from "types/stations"
import { OreveFooter } from "components/OreveFooter.tsx"

export const StationContext = createContext<StationFeature | undefined>(
    undefined
)

export const StationsPage = () => {
    const mmsService = useMmsService()
    const stationService = mmsService.getStationsService()
    const { data, sendRequest: fetchStations } = stationService.useGetStations()
    const [chosenStation, setChosenStation] = useState<
        StationFeature | undefined
    >(undefined)
    const [counter, setCounter] = useState(0)

    const handleStationClick = (station: StationFeature | undefined) => {
        setChosenStation(station)
        setCounter(counter + 1)
    }

    const heightContentPage = "calc(100vh - 80px - 64px - 60px - 1.5rem)"

    useEffect(() => {
        fetchStations()
    }, [])

    return (
        <StationContext.Provider value={chosenStation}>
            <Grid container spacing={3}>
                <Grid size={{xs:8, md:8}} sx={{ height: heightContentPage }}>
                    {data ? (
                        <StationMap
                            chosenStation={chosenStation}
                            geojson={data as StationGeojson}
                            counter={counter}
                        />
                    ) : null}
                </Grid>
                <Grid size={{xs:4, md:4}} sx={{ height: heightContentPage }}>
                    {data ? (
                        <StationList
                            stationSource={(data as StationGeojson).features}
                            handleStationClick={handleStationClick}
                        />
                    ) : null}
                </Grid>
            </Grid>
            <OreveFooter>
                <OreveButton
                    data-testid="download_csv"
                    variant="outlined"
                    value="Exporter en format .csv"
                    icon={SaveAltOutlined}
                />
            </OreveFooter>
        </StationContext.Provider>
    )
}
